'use strict';

/**
 * Component for group view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../../templates/components/detail/field-group.hbs');

var GroupComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },
    },

    hasValue: function() {
        var field = this.getOption('field');

        if (field.sourceFields) {
            return _.any(field.sourceFields, function(fieldName){
                return this.model.getTextValue(fieldName) !== '';
            }.bind(this))
        }

        return true;
    },
});

module.exports = GroupComponent;